<template> 
    <v-dialog v-model="show" v-if="!isDrm" :hide-overlay="phoneOnly" fullscreen transition="slide-x-reverse-transition">
        <v-card v-if="video" class="player-wrapper">
            <!-- <v-toolbar color="black" tile dark elevation="0">
                <v-toolbar-title style="font-size: 1.1rem">{{video.name}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="show = false">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
            </v-toolbar> -->
            <v-btn large :x-large="pcOnly" absolute top :left="phoneOnly" :right="pcOnly" icon dark @click="show = false" :style="`${statusBarOverlay ? 'margin-top: 20px!important;' : ''}`">
                <v-icon v-if="phoneOnly" size="22">mdi-arrow-left</v-icon>
                <v-icon v-else size="22">mdi-close</v-icon>
            </v-btn>

            <div v-if="!appData.hide_video_next_button" :style="`position: absolute; top: 16px; ${phoneOnly ? 'right' : 'left'}: 16px; ${statusBarOverlay ? 'margin-top: 20px!important;' : ''}; `" class="d-flex align-center">
                <v-btn v-if="next" text dark @click="$emit('playNext')" :style="`${statusBarOverlay ? 'margin-top: 20px!important;' : ''}; background-color: rgba(0,0,0, 0.15)`" class="px-4">
                    <v-icon left>mdi-chevron-{{pcOnly ? 'left' : 'right'}}</v-icon>
                    <span>التالي</span>
                </v-btn>
                <v-btn v-if="previous" text dark @click="$emit('playPrevious')" :style="`background-color: rgba(0,0,0, 0.15)`" class="px-4">
                    <span>السابق</span>
                    <v-icon right>mdi-chevron-{{pcOnly ? 'right' : 'left'}}</v-icon>
                </v-btn>
            </div>

            <div v-if="loading" class="d-flex justify-center align-center pa-12">
                <div style="width: 150px">
                    <v-progress-linear color="muted" indeterminate></v-progress-linear>
                </div>
            </div>
            <div class="iframe-wrapper" v-else-if="videoUrl">
                <iframe id="videoIframe" :src="videoUrlComputed" frameborder="0" allowfullscreen allowtransparency allow="autoplay; fullscreen; picture-in-picture; encrypted-media *; accelerometer; gyroscope" :style="bottomSafeArea ? `padding-bottom: ${bottomSafeInsetPx + 8}px!important;` : ''" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CryptoHelper from '@/helpers/crypto'

import AppAPI from '@/app-api'

import {DrmPlayer} from 'capacitor-drmplayer'

export default {
    props: {
        value: {},
        video: {},
        next: {},
        previous: {},
    },
    components: {},
    data(){
        return {
            show: false,
            loading: false,
            videoUrl: null,
            isDrm: false,
        }
    },
    computed: {
        videoUrlComputed(){
            if (!this.videoUrl){
                return null;
            }
            const apiToken = window.localStorage.getItem('tK');
            return `${this.videoUrl}&api_token=${apiToken}`;
        },
        ...GlobalComputed,
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
                this.isDrm = false;
            }
            AppAPI.changeStatusbar(show);
        },
        value(show){
            this.show = show;
            if (show){
                this.loadVideoData();
            }else{
                this.videoUrl = null;
            }
        },
        video(video){
            if (this.video){
                this.loadVideoData();
            }else{
                this.videoUrl = null;
            }
        }
    },
    methods: {
        runDrmPlayer(url, licenseUrl, watermarkId){
            this.isDrm = true;
            watermarkId = watermarkId ? watermarkId.toString() : '';
            DrmPlayer.play({watermarkId, url, licenseUrl}).then(res=>{}).catch(e=>{
                console.error(e);
            });

            DrmPlayer.addListener('close', ()=>{
                this.show = false;
            });
        },
        loadVideoData(){
            if (!this.loading){
                this.loading = true;
                this.isDrm = false;
                window.axios.get('/video/apps/' + this.video.id).then(response=>{
                    let url = CryptoHelper.decrypt(response.data.u);
                    if (response.data.lc){
                        let licenseUrl = CryptoHelper.decrypt(response.data.lc);
                        this.runDrmPlayer(url, licenseUrl, response.data.watermark_id);
                    }else{
                        url = url.replace('&h=1', '');
                        this.videoUrl = url;
                    }
                    
                    
                    this.loading = false;
                }).catch(e=>{
                    this.videoUrl = null;
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء جلب الفيديو، حاول مرة أخرى', 'error');
                    console.error(e)
                })
            }
        },
        ...GlobalMethods,
    },
    mounted(){
        if (this.video){
            this.loadVideoData();
        }
    }
}
</script>

<style lang="scss">
    .player-wrapper{
        position: relative;
        background-color: #000!important;

        .theme--dark.v-toolbar.v-sheet{
            background-color: #000!important;
        }
        .iframe-wrapper{
            display: flex;
            overflow: hidden;
            #videoIframe{
                border: none;
                outline: none;
                width: 100vw;
                height: 100vh;
            }
        }
    }

</style>